import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { GlowComponent } from './glow/glow.component';

@NgModule({
  declarations: [GlowComponent, HeaderComponent, FooterComponent],
  imports: [CommonModule, RouterModule],
  exports: [GlowComponent, HeaderComponent, FooterComponent],
})
export class TemplateModule {}
